import { render } from "./Queue.vue?vue&type=template&id=ba81287c&scoped=true"
import script from "./Queue.vue?vue&type=script&lang=js"
export * from "./Queue.vue?vue&type=script&lang=js"

import "./Queue.vue?vue&type=style&index=0&id=ba81287c&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba81287c"]])

export default __exports__